import React from 'react';
import { i18n } from 'config/locales';
import { Summary, DateSummary } from 'components/Summary';

import { LEGAL, LEGAL_TECHNOLOGY_UNAUTHORIZED } from 'config/formSections/legal';
import Subsection from 'components/Section/shared/Subsection';
import connectSubsection from 'components/Section/shared/SubsectionConnector';
import { EmptyListInstance } from 'forms/shared/models';
import Branch from 'components/Form/Branch';
import Show from 'components/Form/Show';
import Accordion from 'components/Form/Accordion';
import { isPVQForm } from 'helpers/form';
import { formConfig } from 'config/forms';
import { getNumberOfYearsString } from 'helpers/text';
import UnauthorizedItem from './UnauthorizedItem';

const sectionConfig = {
  key: LEGAL_TECHNOLOGY_UNAUTHORIZED.key,
  section: LEGAL.name,
  store: LEGAL.store,
  subsection: LEGAL_TECHNOLOGY_UNAUTHORIZED.name,
  storeKey: LEGAL_TECHNOLOGY_UNAUTHORIZED.storeKey,
};

export class Unauthorized extends Subsection {
  constructor(props) {
    super(props);

    const {
      section, subsection, store, storeKey
    } = sectionConfig;

    this.section = section;
    this.subsection = subsection;
    this.store = store;
    this.storeKey = storeKey;
    this.updateBranch = this.updateBranch.bind(this);
    this.updateList = this.updateList.bind(this);
    this.summary = this.summary.bind(this);
  }

  update = (queue) => {
    this.props.onUpdate(this.storeKey, {
      List: this.props.List,
      HasUnauthorized: this.props.HasUnauthorized,
      ...queue,
    });
  };

  updateList = (values) => {
    this.update({
      List: values,
    });
  };

  updateBranch = (values) => {
    this.update({
      HasUnauthorized: values,
      List: values.value === 'Yes' ? this.props.List : [],
    });
  };

  summary = (item, index) => {
    const o = (item && item.Item) || {};
    const dates = DateSummary(o.Date);

    return Summary({
      type: i18n.t('legal.technology.unauthorized.collection.item'),
      index,
      left: '',
      right: dates,
      placeholder: i18n.t('legal.technology.unauthorized.collection.unknown'),
    });
  };

  render() {
    const { errors } = this.props;
    const accordionErrors = errors && errors.filter((e) => e.indexOf('List.accordion') === 0);
    const isPVQ = isPVQForm(this.props.formType);

    return isPVQ ? (
      <div
        className="section-content legal-technology-unauthorized"
        data-section={LEGAL.key}
        data-subsection={LEGAL_TECHNOLOGY_UNAUTHORIZED.key}
      >
        <h1 className="section-header">{i18n.t('legal.subsection.technology.unauthorized')}</h1>

        <Branch
          name="has_unauthorized"
          label={i18n.t('legal.pvq.technology.unauthorized.heading.title')}
          labelSize="h4"
          className="legal-technology-unauthorized-has-unauthorized"
          {...this.props.HasUnauthorized}
          warning
          onError={this.handleError} // eslint-disable-line @typescript-eslint/unbound-method
          required={this.props.required}
          onUpdate={this.updateBranch} // eslint-disable-line @typescript-eslint/unbound-method
          scrollIntoView={this.props.scrollIntoView}
          attribute="HasUnauthorized"
        />

        <Show when={this.props.HasUnauthorized.value === 'Yes'}>
          <Accordion
            defaultState={this.props.defaultState}
            {...this.props.List}
            scrollToBottom={this.props.scrollToBottom}
            summary={this.summary} // eslint-disable-line @typescript-eslint/unbound-method
            onUpdate={this.updateList} // eslint-disable-line @typescript-eslint/unbound-method
            onError={this.handleError} // eslint-disable-line @typescript-eslint/unbound-method
            errors={accordionErrors}
            description={i18n.t('legal.technology.unauthorized.collection.description')}
            appendTitle={i18n.t('legal.pvq.technology.unauthorized.collection.appendTitle')}
            appendLabel={i18n.t('legal.technology.unauthorized.collection.appendLabel')}
            required={this.props.required}
            scrollIntoView={this.props.scrollIntoView}
            attribute="List"
          >
            <UnauthorizedItem
              name="Item"
              bind
              required={this.props.required}
              formTypes={this.props.formType}
              scrollIntoView={this.props.scrollIntoView}
              addressBooks={this.props.addressBooks}
              dispatch={this.props.dispatch}
              attribute="List"
              formType={this.props.formType}
            />
          </Accordion>
        </Show>
      </div>
    ) : (
      <div
        className="section-content legal-technology-unauthorized"
        data-section={LEGAL.key}
        data-subsection={LEGAL_TECHNOLOGY_UNAUTHORIZED.key}
      >
        <h1 className="section-header">{i18n.t('legal.subsection.technology.unauthorized')}</h1>
        {i18n.m('legal.technology.unauthorized.para.intro')}
        <Branch
          name="has_unauthorized"
          label={i18n.t('legal.technology.unauthorized.heading.title')}
          labelSize="h4"
          className="legal-technology-unauthorized-has-unauthorized"
          {...this.props.HasUnauthorized}
          warning
          onError={this.handleError} // eslint-disable-line @typescript-eslint/unbound-method
          required={this.props.required}
          onUpdate={this.updateBranch} // eslint-disable-line @typescript-eslint/unbound-method
          scrollIntoView={this.props.scrollIntoView}
          attribute="HasUnauthorized"
        />

        <Show when={this.props.HasUnauthorized.value === 'Yes'}>
          <Accordion
            defaultState={this.props.defaultState}
            {...this.props.List}
            scrollToBottom={this.props.scrollToBottom}
            summary={this.summary} // eslint-disable-line @typescript-eslint/unbound-method
            onUpdate={this.updateList} // eslint-disable-line @typescript-eslint/unbound-method
            onError={this.handleError} // eslint-disable-line @typescript-eslint/unbound-method
            errors={accordionErrors}
            description={i18n.t('legal.technology.unauthorized.collection.description')}
            appendTitle={i18n.t('legal.technology.unauthorized.collection.appendTitle')}
            appendLabel={i18n.t('legal.technology.unauthorized.collection.appendLabel')}
            required={this.props.required}
            scrollIntoView={this.props.scrollIntoView}
            attribute="List"
          >
            <UnauthorizedItem
              name="Item"
              bind
              required={this.props.required}
              scrollIntoView={this.props.scrollIntoView}
              addressBooks={this.props.addressBooks}
              dispatch={this.props.dispatch}
              attribute="List"
            />
          </Accordion>
        </Show>
      </div>
    );
  }
}

Unauthorized.defaultProps = {
  name: 'unauthorized',
  HasUnauthorized: {},
  List: EmptyListInstance,
  defaultState: true,
  onUpdate: () => { },
  onError: (value, arr) => arr,
  section: 'legal',
  subsection: 'technology/unauthorized',
  addressBooks: {},
  dispatch: () => { },
  scrollToBottom: '',
  errors: [],
};

export default connectSubsection(Unauthorized, sectionConfig);
